import { createAction, props } from "@ngrx/store";
import { BancoNoticiasOutputDto } from "src/app/domain/DTOs/output/banco-noticias.output.dto";
import { EstruturaRetornoDadosOutputDto } from "src/app/domain/DTOs/output/estrutura-retorno-dados.output.dto";

const actionName = "[ ObterBancoNoticias ] Obter banco noticias";

export const obterBancoNoticias = createAction(
  actionName,
  props<{ inputDto: string}>()
);

export const obterBancoNoticiasSuccess = createAction(
  `${actionName} - Sucesso`,
  props<{ response: EstruturaRetornoDadosOutputDto<BancoNoticiasOutputDto[]> }>()
);

export const obterBancoNoticiasFailure = createAction(
  `${actionName} - Falha`,
  props<{ response: EstruturaRetornoDadosOutputDto<BancoNoticiasOutputDto[]> }>()
);

export const obterBancoNoticiasFinish = createAction(
  `${actionName} - Concluir`
);
